export function extractOptionKeys(varieties = []) {
  const set = new Set()
  varieties.forEach(v => {
    if (v && v.options) {
      Object.keys(v.options).forEach(k => set.add(k))
    }
  })
  return Array.from(set)
}

export function buildOptionValues(varieties = [], selectedOptions = {}) {
  const keys = extractOptionKeys(varieties)
  const map = {}
  keys.forEach(optionKey => {
    const values = new Set()
    varieties.forEach(v => {
      if (!v || !v.options) return
      const candidateValue = v.options[optionKey]
      if (candidateValue == null) return
      const compatible = Object.entries(selectedOptions).every(([k, val]) => {
        if (k === optionKey) return true
        if (!v.options[k]) return false
        return v.options[k] === val
      })
      if (compatible) values.add(candidateValue)
    })
    map[optionKey] = Array.from(values)
  })
  return map
}

export function findMatchingVariant(varieties = [], selectedOptions = {}) {
  if (!varieties.length) return undefined
  if (!selectedOptions || Object.keys(selectedOptions).length === 0) return undefined
  return varieties.find(v => {
    if (!v || !v.options) return false
    return Object.entries(selectedOptions).every(([k, val]) => v.options[k] === val)
  })
}

export function getFallbackVariant(varieties = []) {
  if (!varieties || !varieties.length) return undefined
  return varieties[0]
}

export function resolveImage(product, selectedVariant) {
  if (!product) return ''
  const p = product
  const variant = selectedVariant
  const variantImages = variant && (variant.images || [])
  if (variantImages && variantImages.length && variantImages[0]) return variantImages[0]
  if (variant) {
    if (variant.image) return variant.image
    if (variant.image_1) return variant.image_1
  }
  if (p.images && p.images.length) return p.images[0]
  if (p.image) return p.image
  return ''
}

export function buildOptionsKey(selectedOptions = {}) {
  if (!selectedOptions || !Object.keys(selectedOptions).length) return ''
  return Object.entries(selectedOptions)
    .sort((a, b) => a[0].localeCompare(b[0]))
    .map(([k, v]) => `${k}:${v}`)
    .join('|')
}

export function autopopulateSingletons(varieties = [], selectedOptions = {}) {
  const optionValues = buildOptionValues(varieties, selectedOptions)
  let changed = false
  const next = { ...selectedOptions }
  Object.entries(optionValues).forEach(([k, arr]) => {
    if (arr.length === 1 && next[k] !== arr[0]) {
      next[k] = arr[0]
      changed = true
    }
  })
  return changed ? next : selectedOptions
}

export function resolveVariantAndImage(product, selectedOptions = {}) {
  const varieties = product?.product_varieties || []
  const matched = findMatchingVariant(varieties, selectedOptions)
  const fallback = matched || getFallbackVariant(varieties)
  const image = resolveImage(product, matched || fallback)
  return { variant: matched, fallback, image }
}
